import { render, staticRenderFns } from "./screen-business.vue?vue&type=template&id=1f2bd970&scoped=true"
import script from "./screen-business.vue?vue&type=script&lang=js"
export * from "./screen-business.vue?vue&type=script&lang=js"
import style0 from "./screen-business.vue?vue&type=style&index=0&id=1f2bd970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2bd970",
  null
  
)

export default component.exports